import './App.css';
import Home from './Home'
import About from './About'
import VoterResources from './VoterResources'
import HousingJustice from './HousingJustice'
import PostcardGallery from './PostcardGallery'
import Social from './Social'
import Menu from './Menu'
import Share from './Share'
import ContactUs from './ContactUs'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Routes,
} from "react-router-dom";
import React from 'react';
import ReactGA from 'react-ga4';
const TRACKING_ID = "G-K1MY2DVD24"; // YOUR_OWN_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/voter-resources' element={<VoterResources />} />
        <Route path='/housing-justice' element={<HousingJustice />} />
        <Route path='/postcard-gallery' element={<PostcardGallery />} />
        <Route path='/social' element={<Social />} />
        <Route path='/menu' element={<Menu />} />
        <Route path='/share-your-story' element={<Share />} />
        <Route path='/contact-us' element={<ContactUs />} />
      </Routes>
    </Router>
  )
}

export default App;
